<template>
  <div class="d-flex flex-column g-4">
    <InputView type="text" :placeholder="translate('search')" v-model:value="filter"/>
    <div v-for="module in modules" :key="module.key" class="d-flex flex-column g-2">
      <h3 class="mb-0">
        {{ module.name }}
      </h3>
      <div v-if="module.enabled" class="list-group">
        <div class="list-group-item list-group-item-action" v-for="trigger in module.items" :key="trigger.key" :class="{ disabled: !module.enabled }" @click="$emit('update:trigger', trigger.key)">
          <div class="d-flex align-items-center g-2">
            <i :class="trigger.icon"></i>
            <span>{{ trigger.title }}</span>
          </div>
        </div>
      </div>
      <div v-else class="text-muted small">
        {{ translate("moduleNotEnabled") }}
      </div>
    </div>
    <div v-if="filter && modules.length === 0">

    </div>
  </div>
</template>

<script>
import {InputView} from "@/niftybit";

export default {
  name: "AutomationRuleTriggerForm",
  components: {InputView},
  props: {
    trigger: String,
    triggers: Array
  },
  emits: ["update:trigger"],
  data() {
    return {
      filter: ""
    }
  },
  computed: {
    filtered() {
      return (this.filter.length === 0 ? this.triggers : this.triggers.filter(item => item.title.toLowerCase().includes(this.filter.toLowerCase()) || item.module.name.toLowerCase().includes(this.filter.toLowerCase()))).sort((a, b) => (b.module.enabled ? 1 : 0) - (a.module.enabled ? 1 : 0));
    },
    modules() {
      let list = [...new Set(this.filtered.map(item => item.module.key))];
      return list.map(moduleKey => {
        return Object.assign(this.filtered.find(item => item.module.key === moduleKey).module, {
          items: this.filtered.filter(item => item.module.key === moduleKey)
        });
      });
    },
  }
}
</script>

<style scoped>

</style>